/* @ngInject */
const orderObjectBy = (
  utils,
  valueHandler
) => {
  return (input, attribute) => {
    if (!valueHandler.isObject(input)) return input

    var array = []
    for (var objectKey in input) {
      array.push(input[objectKey])
    }

    array.sort((a, b) => {
      let att = a[attribute]
      let btt = b[attribute]
      if (valueHandler.isNotNull(att)) {
        att = valueHandler.isNumber(att) ? parseInt(att) : att.toLowerCase()
      } else {
        return 1
      }
      if (valueHandler.isNotNull(btt)) {
        btt = valueHandler.isNumber(btt) ? parseInt(btt) : btt.toLowerCase()
      } else {
        return -1
      }
      return valueHandler.isNumber(att) ? att - btt : (att > btt ? 1 : att < btt ? -1 : 0)
    })
    return array
  }
}
export default orderObjectBy



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/utils/orderObjectBy.filter.js